/** @file slotFileName: the file name an image for a slot key must carry: `<drawable>.<entry>.<tile>.png`. */
import { parseSlotKey } from '@zilo/pose3d-format/derive/parseSlotKey';

/** `face/0/4` is `face.0.4.png`; a malformed key is returned with its `/` as dots. */
export function slotFileName(key: string): string {
  const p = parseSlotKey(key);
  return p === null ? `${key.replaceAll('/', '.')}.png` : `${p.drawable}.${String(p.entry)}.${String(p.tile)}.png`;
}
